export default "__VITE_ASSET__CxgFOBKl__"